import { YouthAndSportNumberInput } from '../../lib/types/models/youth-and-sport-number/youth-and-sport-number-input'
import { UpdateInput } from '../../lib/types/utils'
import { API, constructApiUrl } from '../apis.config'
import { restApiClient } from '../rest-api-client'

export function updateYouthAndSportNumber(data: UpdateInput<YouthAndSportNumberInput>) {
  const { id, ...rest } = data
  return restApiClient
    .url(constructApiUrl(API.youthAndSportNumbers.update.url, { id }))
    .patch(rest)
}
